module.exports = "/fonts/ElevanceSans-Bold.2143a2fdfc0ac93ec39e014a2b9d381b.woff2";